// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","title":"Header_title__l+wMf","logo":"Header_logo__shVBB","githubLink":"Header_githubLink__RRiKV"};